export default __webpack_public_path__ + "static/media/thumbnail_image007.6f60c7d4.png";